<template>
  <form name="form" v-on:submit.prevent="submit" v-on:change="changeHandler">
    <div class="card-body">
      <div class="col-xl-12">
        <div class="form-horizontal">
          <selectlist
            :options="titles"
            v-model="form.title_id"
            label="Title"
            name="title"
            :show-error="form.errors.has('title')"
            placeholder="Please Select"
            :error-message="form.errors.get('title')"
          ></selectlist>

          <inputbox
            v-model="form.first_name"
            name="first_name"
            label="First Name"
            :error-message="form.errors.get('first_name')"
            :show-error="form.errors.has('first_name')"
          ></inputbox>

          <inputbox
            v-model="form.last_name"
            name="last_name"
            label="Last Name"
            :error-message="form.errors.get('last_name')"
            :show-error="form.errors.has('last_name')"
          ></inputbox>

          <selectlist
            :options="genders"
            v-model="form.gender_id"
            label="Gender"
            name="gender"
            :show-error="form.errors.has('gender_id')"
            placeholder="Please Select"
            :error-message="form.errors.get('gender_id')"
          ></selectlist>

          <date-of-birth
            v-model="form.date_of_birth"
            :show-error="form.errors.has('date_of_birth')"
          ></date-of-birth>

          <inputbox
            v-model="form.occupation"
            name="occupation"
            label="Occupation"
          ></inputbox>

          <inputbox
            v-model="form.national_insurance"
            name="national_insurance"
            label="National Insurance"
          ></inputbox>

          <selectlist
            :options="securityQuestions"
            v-model="form.security_question_id"
            label="Security Question"
            name="security_question"
            placeholder="Please Select"
            :show-error="form.errors.has('security_question_id')"
          ></selectlist>

          <inputbox
            v-model="form.security_question_answer"
            name="security_question_answer"
            label="Security Question Answer"
            :show-error="form.errors.has('security_question_answer')"
          ></inputbox>

          <input-block
            v-model="form.motoring_convictions"
            name="motoring_convictions"
            label="Motoring convictions within the last 3 years"
          ></input-block>

          <input-block
            v-model="form.prior_claims"
            name="prior_claims"
            label="Claims within the last 5 years"
          ></input-block>

          <input-block
            v-model="form.criminal_convictions"
            name="criminal_convictions"
            label="Criminal convictions within the last 3 years"
          ></input-block>

          <input-block
            v-model="form.illnesses_disabilities"
            name="illnesses_disabilities"
            label="Ilnesses or disabilities reportable to the DVLA"
          ></input-block>

          <fieldset>
            <legend>
              Company Details
              <small class="text-muted"
                >- If hiring for a company add their details here</small
              >
            </legend>

            <inputbox
              v-model="form.company_name"
              name="company_name"
              label="Company Name"
            ></inputbox>

            <inputbox
              v-model="form.vat_number"
              name="vat_number"
              label="VAT Number"
            ></inputbox>
          </fieldset>
          <fieldset>
            <legend>
              Contact Details
              <small class="text-muted"
                >- Enter all of the clients contact details here</small
              >
            </legend>

            <inputbox
              v-model="form.email_address"
              name="email_address"
              label="Email Address"
              :show-error="form.errors.has('email_address')"
            ></inputbox>

            <div class="row">
              <div class="col-md-10 offset-md-2">
                <div class="alert alert-info">
                  <p class="mb-0">
                    The client only needs to provide one contact number.
                  </p>
                </div>
              </div>
            </div>

            <inputbox
              v-model="form.home_telephone"
              name="home_telephone"
              label="Home Telephone"
            ></inputbox>

            <inputbox
              v-model="form.work_telephone"
              name="work_telephone"
              label="Work Telephone"
            ></inputbox>

            <inputbox
              v-model="form.mobile_telephone"
              name="mobile_telephone"
              label="Mobile Telephone"
            ></inputbox>

            <selectlist
              :options="contactMethods"
              v-model="form.contact_method_id"
              label="Preferred Contact Method"
              name="contact_method"
              placeholder="Please Select"
              :show-error="form.errors.has('contact_method_id')"
            ></selectlist>

            <selectlist
              :options="contactTimes"
              v-model="form.contact_time_id"
              label="Preferred Contact Time"
              name="contact_time"
              placeholder="Please Select"
              :show-error="form.errors.has('contact_time_id')"
            ></selectlist>
          </fieldset>
          <fieldset>
            <legend>
              Address Details
              <small class="text-muted"
                >- Enter the clients address details</small
              >
            </legend>
            <address-lookup
              :address="address"
              v-on:address="setAddress"
            ></address-lookup>
          </fieldset>
        </div>
      </div>
    </div>
    <div class="card-footer text-right">
      <form-button :indicator="form.processing()" v-on:clicked="submit"
        >Save</form-button
      >
    </div>
  </form>
</template>
<script>
import Form from './../../../../Classes/Form';

export default {
  props: {
    incident: {
      type: String,
      required: true
    }
  },

  data() {
    return {
      titles: [],
      genders: [],
      securityQuestions: [],
      contactMethods: [],
      contactTimes: [],
      form: new Form(
        {
          title_id: '',
          first_name: null,
          last_name: null,
          gender_id: '',
          date_of_birth: window.DateManager.driverStartingDate(),
          occupation: null,
          national_insurance: null,
          security_question_id: '',
          security_question_answer: null,
          company_name: null,
          vat_number: null,
          motoring_convictions: null,
          prior_claims: null,
          criminal_convictions: null,
          illnesses_disabilities: null,
          email_address: null,
          home_telephone: null,
          work_telephone: null,
          mobile_telephone: null,
          contact_method_id: null,
          contact_time_id: null,
          address_line_one: null,
          address_line_two: null,
          city: null,
          postcode: null
        },
        false
      ),
      client_exists: false,
      data_entered: false
    };
  },

  mounted() {
    this.mount();
  },

  computed: {
    address() {
      return {
        address_line_one: this.form.address_line_one,
        address_line_two: this.form.address_line_two,
        city: this.form.city,
        postcode: this.form.postcode
      };
    }
  },

  methods: {
    mount() {
      window.Ajax.get('/titles')
        .then(response => {
          this.titles = response.data;
        })
        .catch(response => {});

      window.Ajax.get('/genders')
        .then(response => {
          this.genders = response.data;
        })
        .catch(response => {});

      window.Ajax.get('/security-questions')
        .then(response => {
          this.securityQuestions = response.data;
        })
        .catch(response => {});
      window.Ajax.get('/contact-methods')
        .then(response => {
          this.contactMethods = response.data;
        })
        .catch(response => {});
      window.Ajax.get('/contact-times')
        .then(response => {
          this.contactTimes = response.data;
        })
        .catch(response => {});

      window.Ajax.get('/incidents/' + this.incident + '/client')
        .then(response => {
          this.client_exists = true;
          this.form.title_id = response.data.title_id;
          this.form.first_name = response.data.first_name;
          this.form.last_name = response.data.last_name;
          this.form.gender_id = response.data.gender_id;
          this.form.date_of_birth = response.data.date_of_birth
            ? window.DateManager.format(response.data.date_of_birth)
            : null;
          this.form.occupation = response.data.occupation;
          this.form.national_insurance = response.data.national_insurance;
          this.form.security_question_id = response.data.security_question_id;
          this.form.security_question_answer =
            response.data.security_question_answer;
          this.form.company_name = response.data.company_name;
          this.form.vat_number = response.data.vat_number;
          this.form.motoring_convictions = response.data.motoring_convictions;
          this.form.prior_claims = response.data.prior_claims;
          this.form.criminal_convictions = response.data.criminal_convictions;
          this.form.illnesses_disabilities =
            response.data.illnesses_disabilities;
          this.form.email_address = response.data.email_address;
          this.form.home_telephone = response.data.home_telephone;
          this.form.work_telephone = response.data.work_telephone;
          this.form.mobile_telephone = response.data.mobile_telephone;
          this.form.contact_method_id = response.data.contact_method_id;
          this.form.contact_time_id = response.data.contact_time_id;
          this.form.address_line_one = response.data.address_line_one;
          this.form.address_line_two = response.data.address_line_two;
          this.form.city = response.data.city;
          this.form.postcode = response.data.postcode;
        })
        .catch(error => {});
    },

    setAddress(address) {
      this.form.address_line_one = address.address_line_one;
      this.form.address_line_two = address.address_line_two;
      this.form.city = address.city;
      this.form.postcode = address.postcode;
    },

    changeHandler() {
      if (!this.data_entered) {
        this.data_entered = true;
      }
      this.$emit('unsaved-data', this.data_entered);
    },

    submit() {
      if (this.client_exists) {
        this.makeRequest('put');
        // reset monitoring of form changes
        this.data_entered = false;
        this.$emit('unsaved-data', this.data_entered);
        return;
      }

      this.makeRequest('post');
      // reset monitoring of form changes
      this.data_entered = false;
      this.$emit('unsaved-data', this.data_entered);
    },

    makeRequest(method) {
      this.form[method]('/incidents/' + this.incident + '/client')
        .then(response => {
          if (!this.client_exists) {
            this.client_exists = true;
          }

          window.toastify.success(
            'Saved',
            'The client was saved successfully!'
          );
        })
        .catch(error => {
          window.toastify.error(
            'Error',
            "We couldn't save the client - please try again."
          );
        });
    }
  },

  watch: {
    $route(to, from) {
      this.mount();
    }
  }
};
</script>
